import { render, staticRenderFns } from "./SysAnnouncementModal.vue?vue&type=template&id=a8793bca&scoped=true"
import script from "./SysAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./SysAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./SysAnnouncementModal.vue?vue&type=style&index=0&id=a8793bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8793bca",
  null
  
)

export default component.exports